<script>
import MaybachLogoSVG from '../assets/images/maybach_logo_white.svg';

export default {
  name: 'MaybachLogo',
  data() {
    return {
      MaybachLogoSVG,
    };
  },
};
</script>

<template>
  <router-link to="/" class="gl-px-3 gl-py-2 gl-transition-medium">
    <img :src="MaybachLogoSVG" alt="Maybach Systems" />
  </router-link>
</template>
